import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dates'
})
export class SDatePipe implements PipeTransform {
//angular has its own custom pipe as dates so be careful while using this class
  transform(value: string, type?: string): unknown {
    let newValue
    if (value) {
      if(value.includes(' ')){
       let splitArr = value.split(" ")
       let arr = splitArr[0].split('-')
       if(type == 'date_time'){
         newValue = arr[2] + '/' + arr[1] + '/' + arr[0] + ' ' + splitArr[splitArr.length-1]
       }
       else{
        newValue = arr[2] + '/' + arr[1] + '/' + arr[0]
       }
      }
      else{
        let arr = value.split('-');
        newValue = arr[2] + '/' + arr[1] + '/' + arr[0]
      }
    }
    return newValue;
  }
}
